import { useMemo } from 'react'
import { AvatarComponent } from '@rainbow-me/rainbowkit'

import { emojiAvatarForAddress } from './emojiAvatarForAddress'
import { Image, Emoji } from './Style'

export type Props = {
  size: number
  address?: string
  ensImage?: string | null
}

const Avatar: AvatarComponent = ({ address, ensImage, size }: Props) => {
  const { color: backgroundColor, emoji } = useMemo(() => {
    return emojiAvatarForAddress(address)
  }, [address])

  return ensImage ? (
    <Image src={ensImage} width={size} height={size} />
  ) : (
    <Emoji
      style={{
        backgroundColor,
        height: size,
        width: size,
      }}
    >
      {emoji}
    </Emoji>
  )
}

export { Avatar }
